// extracted by mini-css-extract-plugin
export default {"menuItemTooltip":"ToolMenuItem_menuItemTooltip__qnuOF"};